export default __webpack_public_path__ + "13f0850dd7984c82b56b49aeb2f10f05.jpeg";